import { render } from "./AutomateLedgers.vue?vue&type=template&id=17edad82&scoped=true"
import script from "./AutomateLedgers.vue?vue&type=script&lang=js"
export * from "./AutomateLedgers.vue?vue&type=script&lang=js"

import "./AutomateLedgers.vue?vue&type=style&index=0&id=17edad82&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-17edad82"]])

export default __exports__